/* PYNRS Search Redirect (2026-10-29, ported from the Terez theme).
   Rules come from sections/search-redirect.liquid as JSON. A search whose text matches a term exactly (trimmed,
   case-insensitive, spaces collapsed) goes straight to the rule's URL: when any search form is submitted (header
   drawer, results page) and when landing on /search?q=… from a link or browser autocomplete. */
(() => {
  const script = document.querySelector('script[data-pynrs-search-redirects]');
  if (!script) return;

  let rules = [];
  try {
    rules = JSON.parse(script.textContent);
  } catch (e) {
    return;
  }

  const normalize = (value) => (value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const redirects = new Map();
  rules.forEach((rule) => {
    const term = normalize(rule.term);
    if (term && rule.url && !redirects.has(term)) redirects.set(term, rule.url);
  });
  if (!redirects.size) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const searchPath = `${root}search`.replace(/\/{2,}/g, '/');
  const isSearchPath = (pathname) => pathname.replace(/\/$/, '') === searchPath;
  const isSearchForm = (form) => {
    try {
      return isSearchPath(new URL(form.action, window.location.href).pathname);
    } catch (e) {
      return false;
    }
  };

  // capture phase: runs before the theme's own submit handlers on the form
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !isSearchForm(form)) return;
      const input = form.querySelector('input[name="q"]');
      const url = input && redirects.get(normalize(input.value));
      if (!url) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(url);
    },
    true
  );

  if (isSearchPath(window.location.pathname)) {
    const url = redirects.get(normalize(new URLSearchParams(window.location.search).get('q')));
    if (url) window.location.replace(url);
  }
})();
